"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminService = exports.ResponseFix = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
require("rxjs/add/operator/toPromise");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL BITS
const notification_service_1 = require("./notification.service");
const user_service_1 = require("./user.service");
const roles_service_1 = require("./roles.service");
//LOCAL CLASS
class ResponseFix {
}
exports.ResponseFix = ResponseFix;
let AdminService = class AdminService {
    constructor(_http, _talk, _user, _af, _roles) {
        this._http = _http;
        this._talk = _talk;
        this._user = _user;
        this._af = _af;
        this._roles = _roles;
        this.usersURL = "/user";
        this.organizationURL = "/organization";
        this.clientURL = "/client";
        this.permissionURL = "/permission";
        this.roleURL = "/role";
        this.demandPartnerURL = "/demandpartner";
        this.paramURL = "/param";
        this.sizeURL = "/adsize";
        this.integrationURL = "/integration";
        this.cacheURL = "/cache";
        this.filterMetricURL = "/filter";
        this.filterMetricTypeURL = "/filtermetrictype";
        this.purgeCDNURL = "/purge";
        this.beautifierUrl = "/beautifier";
        this.pdmUsers = [];
    }
    setAdminTab(tab) {
        this.adminTab = tab;
    }
    getAdminTab() {
        return this.adminTab;
    }
    createUser(user) {
        return this._http
            .post(this.usersURL, user)
            .toPromise()
            .then(response => this._talk.broadcast(`User created! <i class="fa fa-smile-o" aria-hidden="true"></i>`));
    }
    updateUser(user) {
        if (typeof user.organization != "number") {
            user.organization = user.organization.id;
        }
        return this._http
            .put(this.usersURL + "/" + user.id, {
            email: user.email,
            roles: user.roles,
            organization: user.organization,
        })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    deleteUser({ id }) {
        return this._http
            .post(this.usersURL + "/delete/", { id })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    restoreUser(user) {
        return this._http
            .put(this.usersURL + "/" + user.id, { deleted: false })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    sendWelcomeEmail(email, password) {
        this._http
            .post("/email", {
            template: "welcome",
            email: email,
            password: password,
            subject: "Welcome",
        })
            .toPromise()
            .catch(this._talk.handle);
    }
    createOrganization(organization) {
        return this._http
            .post(this.organizationURL, organization)
            .toPromise()
            .then(response => {
            var client = {
                name: organization.displayName,
                organization: JSON.parse(response._body).id,
                integration: 1,
            };
            return this._http
                .post(this.clientURL, client)
                .toPromise()
                .catch(err => this._talk.broadcast(`Oops. There was an issue creating your organization's default client <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>` +
                err +
                `<br><br>However your new organization has been created`));
        })
            .catch(err => this._talk.broadcast(`Oops. There was an issue creating your organization! <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>` +
            err));
    }
    updateOrganization(org) {
        return this._http
            .put(this.organizationURL + "/" + org.id, {
            displayName: org.displayName,
            roles: org.organization_roles,
        })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    deleteOrganization(org) {
        return this._http
            .delete(`${this.organizationURL}/${org.id}`)
            .toPromise()
            .catch(this._talk.handle);
    }
    restoreOrganization(org) {
        return this._http
            .patch(`${this.organizationURL}/${org.id}`, { deleted: false })
            .toPromise()
            .catch(this._talk.handle);
    }
    createClient(client) {
        return this._http
            .post(this.clientURL, client)
            .toPromise()
            .then(response => {
            this._talk.broadcast(`Client created! <i class="fa fa-smile-o" aria-hidden="true"></i>`);
        })
            .catch(this._talk.handle);
    }
    updateClient(client) {
        return this._http
            .put(this.clientURL + "/" + client.id, {
            name: client.name,
            integration: client.integration,
            domains: client.domains,
        })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    updateRole(role, permissions) {
        return this._http
            .put(this.roleURL + "/" + role, { permissions: permissions })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    updateManager(user, organizations) {
        return this._http
            .put(this.usersURL + "/" + user + "/orgmanage", {
            organizations: organizations,
        })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    switchOrganization(org, userID = this._user.get().id) {
        return this._http
            .put(this.usersURL + "/" + userID, { organization: org })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    createDemandPartner(dp) {
        var newDemandPartnerId;
        return this._http
            .post(this.demandPartnerURL, {
            displayName: dp.name,
            code: dp.code,
            slug: dp.slug,
            logo: dp.slug + ".png",
            minVersion: dp.minVersion,
            type: dp.type,
            gdpr: dp.gdpr,
            tcf2: dp.tcf2,
            ccpa: dp.ccpa,
            schain: dp.schain
        })
            .toPromise()
            .then(response => {
            newDemandPartnerId = JSON.parse(response._body).id;
            this._http
                .post(this.permissionURL, {
                slug: "include-adapter--" + dp.slug,
                displayName: "Include " + dp.name + " Adapter",
                description: "Permits user to use " + dp.name + " Adapter",
            })
                .toPromise()
                .then(response => {
                for (let p in dp.params) {
                    const param = dp.params[p];
                    if (param.subType) {
                        this._http
                            .post(this.paramURL, {
                            paramName: param.paramName,
                            paramType: param.paramType,
                            required: param.required,
                            subType: param.subType,
                            partner: newDemandPartnerId,
                        })
                            .toPromise()
                            .catch(response => {
                            return this._talk.broadcast("there was an issue creating your demand partner:" +
                                response);
                        });
                    }
                    else {
                        this._http
                            .post(this.paramURL, {
                            paramName: param.paramName,
                            paramType: param.paramType,
                            required: param.required,
                            partner: newDemandPartnerId,
                        })
                            .toPromise()
                            .catch(response => {
                            return this._talk.broadcast("there was an issue creating your demand partner:" +
                                response);
                        });
                    }
                }
                this._talk.broadcast(`Permission created! Don't forget to include the newly created permission for the demand partner in the proper organizational role <i class="fa fa-smile-o" aria-hidden="true"></i>`);
            })
                .catch(response => {
                return this._talk.broadcast("there was an issue creating your demand partner:" + response);
            });
        });
    }
    createSize(size) {
        return this._http
            .post(this.sizeURL, { width: size.width, height: size.height })
            .toPromise()
            .then(response => {
            this._talk.broadcast(`Size created! <i class="fa fa-smile-o" aria-hidden="true"></i>`);
        })
            .catch(err => this._talk.broadcast(`Oops. There was an issue creating your size! <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>` +
            err));
    }
    createIntegration(integration, clientName) {
        return this._http
            .post(this.integrationURL, {
            displayName: clientName,
            enableLineItemAutomation: integration.enableLineItemAutomation,
            staticTimeout: integration.staticTimeout,
            minTimeout: integration.minTimeout,
            maxTimeout: integration.maxTimeout,
            fastBandwidth: integration.fastBandwidth,
            slowBandwidth: integration.slowBandwidth,
            adUnitHardFloor: integration.adUnitHardFloor,
            gptInstantLoad: integration.gptInstantLoad,
            enableServices: integration.enableServices,
            internalRefresh: integration.internalRefresh,
            pubCommonId: integration.pubCommonId,
            randomizeDemandPartner: integration.randomizeDemandPartner,
            dAUT: integration.dAUT,
            dAUTF: integration.dAUTF,
            queRefresh: integration.queRefresh,
            onlyTargetSlotDivId: integration.onlyTargetSlotDivId,
            onlyTargetSlotCode: integration.onlyTargetSlotCode,
            instantAuction: integration.instantAuction,
            waitForSlotDefinition: integration.waitForSlotDefinition,
            guaranteedRefresh: integration.guaranteedRefresh,
            immediateFirePixel: integration.immediateFirePixel,
            refreshOption: integration.refreshOption,
            newUnitGeneration: integration.newUnitGeneration,
            castTAsInteger: integration.castTAsInteger,
            enforceGDPRDemandPartners: integration.enforceGDPRDemandPartners,
            enforceCCPADemandPartners: integration.enforceCCPADemandPartners,
            enforceTCF2DemandPartners: integration.enforceTCF2DemandPartners,
        })
            .toPromise()
            .then(response => {
            console.log("NEW INTEGRATION CREATED FOR " + clientName + " !!!");
            return JSON.parse(response._body).id;
        })
            .catch(this._talk.handle);
    }
    updateIntegration(integration) {
        return this._http
            .put(this.integrationURL + "/" + integration.id, {
            enableLineItemAutomation: integration.enableLineItemAutomation,
            staticTimeout: integration.staticTimeout,
            minTimeout: integration.minTimeout,
            maxTimeout: integration.maxTimeout,
            fastBandwidth: integration.fastBandwidth,
            slowBandwidth: integration.slowBandwidth,
            adUnitHardFloor: integration.adUnitHardFloor,
            gptInstantLoad: integration.gptInstantLoad,
            enableServices: integration.enableServices,
            internalRefresh: integration.internalRefresh,
            pubCommonId: integration.pubCommonId,
            randomizeDemandPartner: integration.randomizeDemandPartner,
            dAUT: integration.dAUT,
            dAUTF: integration.dAUTF,
            queRefresh: integration.queRefresh,
            onlyTargetSlotDivId: integration.onlyTargetSlotDivId,
            onlyTargetSlotCode: integration.onlyTargetSlotCode,
            instantAuction: integration.instantAuction,
            waitForSlotDefinition: integration.waitForSlotDefinition,
            guaranteedRefresh: integration.guaranteedRefresh,
            immediateFirePixel: integration.immediateFirePixel,
            refreshOption: integration.refreshOption,
            newUnitGeneration: integration.newUnitGeneration,
            castTAsInteger: integration.castTAsInteger,
            enforceGDPRDemandPartners: integration.enforceGDPRDemandPartners,
            enforceCCPADemandPartners: integration.enforceCCPADemandPartners,
            enforceTCF2DemandPartners: integration.enforceTCF2DemandPartners,
        })
            .toPromise()
            .then()
            .catch(this._talk.handle);
    }
    massUpdate(adEngineVersion) {
        //calls the massSave function on the AdController
        return this._http
            .post("/bidder/massUpdateVersion", { version: adEngineVersion })
            .toPromise()
            .then(res => { });
    }
    pullUsers() {
        return this._http
            .get(this.usersURL)
            .toPromise()
            .then(response => {
            return JSON.parse(response._body);
        })
            .catch(this._talk.handle);
    }
    pullUsersWithConnectPDMRole() {
        return this._http
            .get(this.usersURL + "/role/" + this._roles.getRoleBySlug("connect_pdm").id)
            .toPromise()
            .then(response => {
            return JSON.parse(response._body);
        })
            .catch(this._talk.handle);
    }
    clearCurrentUserFilterCache() {
        return this._http
            .post(this.cacheURL + "/del", { key: ":FILTERS_ALL:", options: true })
            .toPromise()
            .then(response => {
            return JSON.parse(response._body);
        })
            .catch(this._talk.handle);
    }
    getUserById(id) {
        return this._http
            .get(this.usersURL + "/" + id)
            .toPromise()
            .then(response => {
            return JSON.parse(response._body);
        })
            .catch(this._talk.handle);
    }
    getUserByEmail(email) {
        return this._http
            .get(this.usersURL + "/" + email)
            .toPromise()
            .then(response => {
            return JSON.parse(response._body);
        })
            .catch(this._talk.handle);
    }
    populateFilterMetrics(dateRange) {
        return this._http
            .post(this.filterMetricURL + "/populate", { dateRange })
            .toPromise()
            .then(response => {
            return JSON.parse(response._body);
        })
            .catch(this._talk.handle);
    }
    checkPurgeFile(iID, isFullPath) {
        let endpt;
        if (isFullPath) {
            endpt = `${this.purgeCDNURL}/${iID.split("brealtime.com/")[1].split(".js")[0]}`;
        }
        else {
            endpt = `${this.purgeCDNURL}/${iID}`;
        }
        return this._http
            .get(endpt)
            .toPromise()
            .then(response => response);
    }
    runFilePurge(iID, isFullPath) {
        if (isFullPath) {
            iID = btoa(iID);
        }
        return this._http
            .get(`${this.purgeCDNURL}/confirmed/${iID}?isFullPath=${isFullPath}`)
            .toPromise()
            .then(response => response);
    }
};
exports.AdminService = AdminService;
exports.AdminService = AdminService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        user_service_1.UserService,
        core_1.ApplicationRef,
        roles_service_1.RolesService])
], AdminService);
//# sourceMappingURL=admin.service.js.map